import { FaQuoteLeft } from "react-icons/fa";
import userImg from "../../../assets-user/userImg.png";

const LoginTestimonials = () => {
  return (
    <div className="w-full bg-gray-50 px-4 sm:px-6 lg:px-10 py-10">
      <div className="mx-auto">
        {/* Header Section */}
        <div className="text-center">
          <h2
            className="font-[Poppins] font-medium text-[28px] md:text-[32px] leading-[150%] tracking-[1%]"
            data-aos="fade-down"
            data-aos-duration="600"
          >
            What people tell about us?
          </h2>
          <p
            className="text-[#919191] font-[Poppins] font-normal text-[18px] leading-[150%] tracking-[1%] w-full lg:w-[55%] mx-auto text-justify mt-2 lg:text-center"
            data-aos="fade-up"
            data-aos-duration="600"
            data-aos-delay="100"
          >
            Hear from our happy buyers, sellers, and partners who trusted
            LeadBook to make their property journey simple, transparent, and
            hassle-free.
          </p>
        </div>

        {/* Testimonial Card - Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          {/* Image  */}
          <div
            className="lg:col-span-2 relative flex-shrink-0"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            {/* Person Image */}
            <div className="">
              <img
                src={userImg}
                alt="Happy customer"
                className="w-full h-full object-cover rounded-full"
                data-aos="zoom-in"
                data-aos-duration="800"
                data-aos-delay="400"
              />
            </div>
          </div>

          {/* Testimonial Content - Takes 3 columns and centered vertically */}
          <div
            className="lg:col-span-3 flex items-center"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <div className="w-full">
              {/* Quote Icon */}
              <div
                className="mb-6"
                data-aos="zoom-in"
                data-aos-duration="500"
                data-aos-delay="500"
              >
                <FaQuoteLeft className="text-4xl lg:text-6xl text-[#FFCEC5]" />
              </div>

              {/* Testimonial Text */}
              <p
                className="text-[#919191] font-[Poppins] font-normal text-[24px] leading-[150%] tracking-[1%]"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay="600"
              >
                "LeadBook made my home search so easy. The verified listings
                gave me confidence, and I connected directly with the builder—no
                brokerage, no stress!"
              </p>

              {/* Author */}
              <div
                className="border-t border-gray-200 pt-4"
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="800"
              >
                <p className="text-[#676767] font-[Poppins] font-semibold text-[21.22px] leading-[150%] tracking-[1%]">
                  — Rubina S., Pune
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginTestimonials;
